/* Manukind cart drawer extras (v18). Works on top of custom-cart-drawer.js without changing it:
   - express checkout (Shop Pay, PayPal) under the checkout button, fetched once per open while the cart has items
   - one line with delivery time and the returns rule (same wording as the PDP "Shipping and returns")
   - checkout button on brand brown (white on #FFB600 was 1.76:1) and the v17 fonts in the drawer */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var INFO = 'Delivered in 2–5 business days · Unopened items can be returned within 30 days · ';
  var SHIP_UNDER = 'Standard US shipping is $9.99 under $50. ';
  var loadedFor = -1, loading = false;

  function style() {
    if (document.getElementById('mk-cart-extras-css')) return;
    var s = document.createElement('style'); s.id = 'mk-cart-extras-css';
    s.textContent = [
      '#fcd-drawer{--fcd-font-heading:"kit-rounded","Arial Rounded MT Bold",sans-serif;--fcd-font-body:"kit-sans","Helvetica Neue",Arial,sans-serif;font-family:var(--fcd-font-body)}',
      '#fcd-drawer .fcd-checkout-btn{background:#553822;color:#FBF7F0}',
      '#fcd-drawer .fcd-checkout-btn:hover{background:#3f2918;box-shadow:none}',
      '#fcd-drawer .fcd-login-btn,#fcd-drawer .fccs-btn-add{background:#FFB600;color:#553822}',
      '#fcd-drawer .fcd-login-btn:hover,#fcd-drawer .fccs-btn-add:hover{background:#f0a800;color:#553822}',
      '#fcd-drawer .mk-fcd-express:empty{display:none}',
      '#fcd-drawer .mk-fcd-express{margin-top:10px;--shopify-accelerated-checkout-button-block-size:44px;--shopify-accelerated-checkout-button-inline-size:44px;--shopify-accelerated-checkout-button-border-radius:8px;--shopify-accelerated-checkout-row-gap:8px}',
      '#fcd-drawer .mk-fcd-info{margin:10px 0 0;font-size:12px;line-height:1.45;color:#5a5043;text-align:center}',
      '#fcd-drawer .mk-fcd-info a{color:#553822;text-decoration:underline}',
      '#fcd-drawer.mk-empty .fcd-footer{display:none}',
      '@media (max-width:767px){#fcd-drawer .fcd-footer.mk-x{max-height:none}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function decorate(drawer) {
    var footer = drawer.querySelector('.fcd-footer');
    if (!footer) return null;
    if (!footer.querySelector('.mk-fcd-info')) {
      var btn = footer.querySelector('.fcd-checkout-btn');
      var ex = document.createElement('div'); ex.className = 'mk-fcd-express';
      var info = document.createElement('p'); info.className = 'mk-fcd-info';
      info.innerHTML = '<span class="mk-fcd-ship"></span>' + INFO + '<a href="' + ROOT.replace(/\/$/, '') + '/policies/refund-policy">Returns policy</a>';
      if (btn) { btn.insertAdjacentElement('afterend', info); btn.insertAdjacentElement('afterend', ex); }
      else { footer.appendChild(ex); footer.appendChild(info); }
      footer.classList.add('mk-x');
    }
    return footer;
  }

  function count() { var c = window._fcdCart; return c && typeof c.item_count === 'number' ? c.item_count : null; }

  function express(drawer) {
    var footer = decorate(drawer); if (!footer) return;
    var box = footer.querySelector('.mk-fcd-express'), n = count();
    if (n === 0) { box.innerHTML = ''; loadedFor = -1; return; }
    if (loading || (loadedFor > 0 && box.querySelector('shopify-accelerated-checkout-cart'))) return;
    loading = true;
    fetch(ROOT + '?section_id=mk-cart-express', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var el = tmp.querySelector('.additional-checkout-buttons');
        box.innerHTML = '';
        if (el) { box.appendChild(el); loadedFor = n || 1; }
      })
      .catch(function () {})
      .then(function () { loading = false; });
  }

  function refresh(drawer) {
    var c = window._fcdCart; if (!c) return;
    drawer.classList.toggle('mk-empty', c.item_count === 0);
    var s = drawer.querySelector('.mk-fcd-ship');
    if (s) { var t = c.total_price > 0 && c.total_price < 5000 ? SHIP_UNDER : ''; if (s.textContent !== t) s.textContent = t; }
  }

  function watch(drawer) {
    decorate(drawer); refresh(drawer);
    var footer = drawer.querySelector('.fcd-footer');
    if (footer) new MutationObserver(function () { refresh(drawer); }).observe(footer, { subtree: true, characterData: true, childList: true });
    if (drawer.classList.contains('is-open')) express(drawer);
    new MutationObserver(function () { if (drawer.classList.contains('is-open')) express(drawer); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    style();
    [].forEach.call(document.querySelectorAll('video img:not([alt])'), function (i) { i.alt = ''; });
    var d = document.getElementById('fcd-drawer');
    if (d) { watch(d); return; }
    var mo = new MutationObserver(function () {
      var dr = document.getElementById('fcd-drawer');
      if (dr) { mo.disconnect(); watch(dr); }
    });
    mo.observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
